module.exports = __webpack_public_path__ + "img/trial1-2.3b886bfe.png";